import { useState, useEffect } from 'react';

/**
 * Custom hook for tracking active section based on scroll position
 * Uses throttling to optimize performance
 */
export function useScrollSection(offset: number = 100): string {
  const [activeSection, setActiveSection] = useState<string>('home');

  useEffect(() => {
    let ticking = false;

    const handleScroll = (): void => {
      if (!ticking) {
        window.requestAnimationFrame(() => {
          const sections = document.querySelectorAll('section[id]');
          const scrollY = window.pageYOffset;

          sections.forEach((section) => {
            const htmlSection = section as HTMLElement;
            const sectionHeight = htmlSection.offsetHeight;
            const sectionTop = htmlSection.getBoundingClientRect().top + window.pageYOffset - offset;
            const sectionId = htmlSection.getAttribute('id');

            if (scrollY > sectionTop && scrollY <= sectionTop + sectionHeight && sectionId) {
              setActiveSection(sectionId);
            }
          });

          ticking = false;
        });

        ticking = true;
      }
    };

    // Initial check
    handleScroll();

    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, [offset]);

  return activeSection;
}











